import { AppModule } from '@thoughtspot/blink-context';
import React, { useEffect } from 'react';
import { NavHubContextProvider } from '/@contexts/nav-hub-context';
import { getAppModule } from '../../../routing/routes-util';
import { LeftNavigationHub } from './left-navigation-hub.container';
import styles from './left-navigation-overlay-hub.module.scss';

export interface LeftNavigationOverlayHubInterface {
    setShowLeftNavigationOverlayHub: (value: boolean) => void;
}

export const LeftNavigationOverlayHub: React.FC<LeftNavigationOverlayHubInterface> = ({
    setShowLeftNavigationOverlayHub,
}) => {
    const leftNavigationOverlayHubRef = React.useRef(null);
    const shouldWrapWithNavPanelContext = getAppModule() === AppModule.Develop;

    const outsideClickToHideLeftNavigationOverlayHub = (event: MouseEvent) => {
        const isClickInsidePanel = leftNavigationOverlayHubRef.current?.contains(
            event.target as Node,
        );
        if (!isClickInsidePanel) {
            setShowLeftNavigationOverlayHub(false);
        }
    };

    useEffect(() => {
        document.addEventListener(
            'mousedown',
            outsideClickToHideLeftNavigationOverlayHub,
        );
        return () => {
            document.removeEventListener(
                'mousedown',
                outsideClickToHideLeftNavigationOverlayHub,
            );
        };
    }, []);

    const wrappedContent = (children: any) =>
        shouldWrapWithNavPanelContext ? (
            <NavHubContextProvider>{children}</NavHubContextProvider>
        ) : (
            children
        );

    const renderContent = () => (
        <div
            className={styles.leftNavigationOverlayHub}
            ref={leftNavigationOverlayHubRef}
        >
            <LeftNavigationHub />
        </div>
    );

    return wrappedContent(renderContent());
};
